var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAurora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAwlJREFUaEPVmkGS0kAUht9rdNbjDXBpKQg3IDsNM1V4ghn2CrmB5Q0iHgA8wcxUKbqDG0CFsVzKDWQt0M/qjEmFEEh3uhMiW5rX7/v/Tof0HwTDH2dx0SKiK2DUIoKqKI8IcwCcI+d3bv3brckp0VQx52enSpv1kIBaR2siLFnlzHKf3S5NzG0EwPlhNzjHCQCdSza1Ygws9/l4Ljn+4DBtAKE836xn8eYRYQkklo5YQ9AIllOkkxV7dNbUdUIboH9v/9ppTiwRYl239mUalc3x7Gti8D46FgGnH2tfLR0XtADeefY1IgzDBkTza265ze+J69uZvarSYzaJQjBgVhxWBUgLIK4+EXQ/1cejYw2IXYoDnwRjdF3IDJCk/uDF+KmMev1FexLdrXRcyAyQRf0AzqQLmQB01A8gTLmQCUBHfdMuKAOYUN+kC8oAJtQ36YISgEn1TbmgBGBSfVMuSAPkob4JF6QB8lDfhAtSAHmqr+uCFECe6uu6kApQhPo6LqQCFKG+jgtHAYpUP6sLRwGKVD+rCwcBTqF+FhcOApxC/SwuJAKcUn1VFxIBTqm+qgt7AGVQX8WFPYAyqK/iwg5AmdSXdWEHoEzqy7oQApRRfRkXQoAyqi/jgg9QZvXTXPAByqx+mgv41rvsMNzehGeaCEvZM06Zc1CTY5JO87B/3x4S0XUwkcwJs8mmVGrtnakijLC3aIt0peEXKrH6AWjPa/8G/BdlISyxt7ApVIHgblAfd1RUKXpsf3FxQ8DDHv9/gNgOtBrUxk+KVlVlvmi/In/Gnvd6BIhXQRGdtESlkSxj4/crFBdx/MoWF7LJIDpLo0m/8YP07Z/dgJDozcONLJZZCQji8CEtsDPVXFod//UF5MN4nCvuVz6AiD95pTILt6egotimRFhNuEqbJJfvkc4JsLX/BgCu2GbbFHFu+GfOmdkNXsHJHkQunekUFc2T5TYfXlPYeR5ICqJ1pjL9W5Ep42bbjQbpiQ/1jnfZ4bDpILKXFNylTXcjWc9/54LjFBE/JyX6fwHbfZEs3yiLEwAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAurora);
export default __webpack_public_path__ + "static/media/aurora.d53363af59c3fee12c43cb8e9aaa2b29.svg";
export { ForwardRef as ReactComponent };